<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useGetVersion } from '@/version/api/getVersion';
import { useActionFailedAlert } from 'shared/problems/composables/actionFailedAlert';

const version = ref('');

const getVersion = useGetVersion();
const actionFailedAlert = useActionFailedAlert();

onMounted(async () => {
  const response = await getVersion.execute();

  if (!response.ok) {
    actionFailedAlert.show(response.details);
    return;
  }

  version.value = response.body.version;
});
</script>

<template>
  <div>{{ version }}</div>
</template>
